import { Component, computed, input } from '@angular/core';

import { CertificationItem } from '@mitsubishi/shared/data-access';
import { IconComponent } from '@mitsubishi/shared/ui';
import { ApmIcons } from '@mitsubishi/ui/icons';

const certificationMap = {
  2: 'ahri',
  3: 'china',
  4: 'eurovent',
};

@Component({
  selector: 'apm-study-certificate-icon',
  templateUrl: './study-certificate-icon.component.html',
  styleUrl: './study-certificate-icon.component.scss',
  imports: [IconComponent],
})
export class StudyCertificateIconComponent {
  readonly projectCertifications = input.required<{ [key: string]: CertificationItem }>();

  readonly certificationId = computed<number | undefined>(() => {
    return Object.values(this.projectCertifications()).find(
      cert => certificationMap[cert.certificationId] !== undefined
    )?.certificationId;
  });

  readonly size = input<'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl'>('md');

  readonly icon = computed<ApmIcons | null>(() =>
    this.certificationId() ? (`i_certificate_${certificationMap[this.certificationId()!]}` as ApmIcons) : null
  );
}
